export default {

    state() {
        return {
            user: {},
            language: {},
            hrefPrefix: '',
            isLoading: false,
            isSearching: false,
            searchingFor: null,
            notifyDialog: {
                isOn: false,
            }
        }
    },

    getters: {
        getUser(state) { //take parameter state
            return state.user;
        },
        getCart(state) { //take parameter state
            return state.cart;
        }
    },

    actions: {
        getUser(context) {
            axios.default.get("/api/user")
                .then((response) => {
                    console.log(response.data);
                    context.commit("setUser", response.data);
                })
                .catch((error) => {
                    console.error(error.response);
                })
        },
    },

    mutations: {
        increment (state) {
            state.count++
        },
        showNotifyDialog(state, payload) {
            state.notifydialog = {
                isOn: true,
                title: payload.title,
                text: payload.text,
                buttonText: payload.buttonText ?? 'OK'
            }
        },
        setUser(state, payload) {
            state.user = payload;
        },
        setLanguage(state, payload) {
            state.language = payload;
        },
        setHrefPrefix(state, payload) {
            state.hrefPrefix = payload;
        },
        setSearchingFor(state, payload) {
            state.searchingFor = payload;
        },
    }
}
